import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function validJsonValidator(isOptional = false): ValidatorFn  {
	return (control: AbstractControl): ValidationErrors | null => {
		if (!control.value && isOptional) {
			return null; // empty value is valid
		}
		try {
			JSON.parse(control.value);
			return null; // valid JSON
		} catch (e) {
			return {invalidJson: true}; // invalid JSON
		}
	}
}
